import { EventDispatcher } from '@libshaun/ts-event-dispatcher'

export const dispatcher = new EventDispatcher()
